import { MouseEvent, useRef, useState } from 'react';

import { MENU_TYPE } from '~features/home/constants';
import { MenuItemObj } from '~types/common';

import * as S from './style';

interface Props {
  selectedMenuId?: MENU_TYPE;
  menuList: MenuItemObj<MENU_TYPE>[];
  onClick?: (menuType: MENU_TYPE) => void;
}

export default function Tabs({ selectedMenuId, menuList, onClick }: Props) {
  const wrapperRef = useRef<HTMLUListElement>(null);

  const handleClick = (e: MouseEvent<HTMLElement>, _selectedMenuId: MENU_TYPE) => {
    if (_selectedMenuId === selectedMenuId) {
      return;
    }

    const { offsetLeft, offsetWidth } = e.currentTarget;

    if (wrapperRef.current) {
      const spacingForCenter = (wrapperRef.current?.offsetWidth - offsetWidth) / 2;
      wrapperRef.current.scrollTo({ left: offsetLeft - spacingForCenter, behavior: 'smooth' });
    }

    if (onClick) {
      onClick(_selectedMenuId);
    }
  };

  return (
    <S.MenuWrapper ref={wrapperRef}>
      {menuList.map(({ id, text }) => (
        <S.MenuItem key={id} onClick={(e) => handleClick(e, id)} $selected={selectedMenuId === id}>
          <S.Anchor>{text}</S.Anchor>
        </S.MenuItem>
      ))}
    </S.MenuWrapper>
  );
}
